import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ShieldCheck, Gavel, Info } from 'lucide-react';

const Licenses: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto py-8 md:py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8 text-center">
          Licenças e Regulamentação
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <Card className="bg-secondary/30 border-border">
            <CardHeader className="flex flex-row items-center space-x-4 pb-4">
              <ShieldCheck className="h-8 w-8 text-primary" />
              <CardTitle className="text-xl font-bold text-foreground">Nossa Licença</CardTitle>
            </CardHeader>
            <CardContent className="text-muted-foreground">
              <p className="mb-4">
                Operamos sob a licença de jogos online emitida pela Autoridade de Jogos de Curaçao,
                garantindo um ambiente de jogo justo e seguro para todos os nossos usuários.
              </p>
              <p className="mb-2">
                <strong>Autoridade Emissora:</strong> Curaçao eGaming
              </p>
              <p className="mb-2">
                <strong>Número da Licença:</strong> #12345/JAZ
              </p>
              <p className="mb-2">
                <strong>Data de Emissão:</strong> 01 de Janeiro de 2023
              </p>
              <p>
                <strong>Validade:</strong> 31 de Dezembro de 2028
              </p>
              <p className="mt-4 text-sm">
                Para verificar a validade da nossa licença, você pode visitar o site oficial da Curaçao eGaming.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-secondary/30 border-border">
            <CardHeader className="flex flex-row items-center space-x-4 pb-4">
              <Gavel className="h-8 w-8 text-primary" />
              <CardTitle className="text-xl font-bold text-foreground">Regulamentação e Conformidade</CardTitle>
            </CardHeader>
            <CardContent className="text-muted-foreground">
              <p className="mb-4">
                Estamos em total conformidade com as leis e regulamentos internacionais de jogos online.
                Nossa plataforma é auditada regularmente para garantir a integridade dos jogos e a proteção dos dados dos usuários.
              </p>
              <p className="mb-2">
                <strong>Jogo Responsável:</strong> Promovemos o jogo responsável e oferecemos ferramentas para ajudar
                nossos usuários a manterem o controle de suas atividades de jogo.
              </p>
              <p className="mb-2">
                <strong>Segurança dos Dados:</strong> Utilizamos tecnologia de criptografia avançada para proteger
                todas as transações e informações pessoais dos nossos usuários.
              </p>
              <p className="mt-4 text-sm">
                Para mais informações sobre jogo responsável, visite nossa seção dedicada.
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="text-center text-muted-foreground mt-12">
          <p className="text-lg">
            <Info className="inline-block h-5 w-5 mr-2 text-accent" />
            A sua segurança e a justiça dos nossos jogos são as nossas maiores prioridades.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Licenses;
